import { BusinessCenter } from '@mui/icons-material'
import PmiCreate from './PmiCreate'
import PmiEdit from './PmiEdit'
import PmiList from './PmiList'

const businessIndex = {
  icon: BusinessCenter,
  create: PmiCreate,
  edit: PmiEdit,
  list: PmiList,
}

export default businessIndex
